export const API_ENDPOINTS = {
    AUTO_ENROLL_CANDIDATES: `/v1/operations/auto-enroll-candidates`,
    AUTO_ENROLL_ENROLLEES: '/v1/operations/auto-enroll',
    WELLNESS_HOUR: '/v1/users/:userId/wellness-hour'
}